import { Col, DatePicker, Form, Input, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { GET_BUYER_ENDPOINT, SUB_CONTRACT_FACTORY } from "apiServices/API_ENDPOINTS";
import { getData } from "apiServices/common";
import { storeRequisitionMovementTypes } from "components/Production/StoreRequisition/constants";
import "./FabricStoreEntryFilterFields.css";

const { Option } = Select;

const STATUS_OPTIONS = [
  { label: "Pending", value: "pending" },
  { label: "Approved", value: "approved" },
  { label: "Rejected", value: "rejected" },
  { label: "Checked", value: "checked" },
  { label: "Acknowledged", value: "acknowledged" },
];

const StoreRequisitionFilterFields = () => {
  const [buyerList, setBuyerList] = useState([]);
  const [factoryList, setFactoryList] = useState([]);

  const getBuyerList = useCallback(async (filterValues = {}) => {
    const response = await getData(GET_BUYER_ENDPOINT, false, {
      per_page: 500,
      ...filterValues,
    });
    if (response?.data?.code === 200 || response?.status === 200) {
      setBuyerList(response?.data?.data?.data || []);
    }
  }, []);

  const getFactoryList = useCallback(async (filterValues = {}) => {
    const response = await getData(SUB_CONTRACT_FACTORY, false, {
      per_page: 500,
      ...filterValues,
    });
    if (response?.data?.code === 200 || response?.status === 200) {
      setFactoryList(response?.data?.data?.data || []);
    }
  }, []);

  useEffect(() => {
    getBuyerList();
    getFactoryList();
  }, [getBuyerList, getFactoryList]);

  return (
    <>
      <Col span={3}>
        <Form.Item label="Movement Type" name="movement_type">
          <Select
            showSearch
            allowClear
            placeholder="Select movement type"
            optionFilterProp="children"
            size="small"
            style={{ width: "100%" }}
          >
            {storeRequisitionMovementTypes.map((type) => (
              <Option key={type.id} value={type.value}>
                {type.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Buyer" name="buyer_id">
          <Select
            showSearch
            allowClear
            placeholder="Select buyer"
            optionFilterProp="children"
            size="small"
            style={{ width: "100%" }}
            onSearch={(value) => getBuyerList({ name: value })}
            onClear={() => getBuyerList()}
          >
            {buyerList.map((buyer) => (
              <Option key={buyer.id} value={buyer.id}>
                {buyer.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Factory" name="sub_contract_factory_id">
          <Select
            showSearch
            allowClear
            placeholder="Select factory"
            optionFilterProp="children"
            size="small"
            style={{ width: "100%" }}
            onSearch={(value) => getFactoryList({ name: value })}
            onClear={() => getFactoryList()}
          >
            {factoryList.map((factory) => (
              <Option key={factory.id} value={factory.id}>
                {factory.name}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item
          label="Entry Date"
          name="entry_date"
          className="fabric-store-entry-filter-date-item"
        >
          <DatePicker
            className="fabric-store-entry-filter__date"
            style={{ width: "100%" }}
            format="YYYY-MM-DD"
            // size="small"
            allowClear
          />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item
          label="Requisition No"
          name="requisition_no"
          className="fabric-store-entry-filter-text-item"
        >
          <Input
            className="fabric-store-entry-filter__text-input"
            placeholder="Requisition no"
            size="small"
            allowClear
          />
        </Form.Item>
      </Col>
      <Col span={3}>
        <Form.Item label="Status" name="status">
          <Select
            showSearch
            allowClear
            placeholder="Select status"
            optionFilterProp="children"
            size="small"
            style={{ width: "100%" }}
          >
            {STATUS_OPTIONS.map((status) => (
              <Option key={status.value} value={status.value}>
                {status.label}
              </Option>
            ))}
          </Select>
        </Form.Item>
      </Col>
    </>
  );
};

export default StoreRequisitionFilterFields;
